import { OpenDataIndicator } from '../../interfaces/OpenData'
import IndicatorCard from '../../views/OpenData/components/Indicators/IndicatorCard'

const OpenDataMapper = ({ indicators }: { indicators: OpenDataIndicator[], }) => {

    return (
        <div className="flex flex-col items-center mt-6 gap-4">
            {indicators && indicators.length &&
                indicators.map((item) => (
                    <IndicatorCard key={item.id} indicator={item} />
                ))}
        </div>
    )
}

export default OpenDataMapper